/**
 * Formats a capture timestamp as "YYYY-MM-DD HH:mm" in the viewer's local
 * timezone. Ported from the portal's `relativeTime.ts` (flat absolute 24h
 * timestamps per Luis's request) but implemented with native Date so the
 * shared package carries no dayjs dependency.
 */
export function formatCapturedTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}`
  );
}
